// extracted by mini-css-extract-plugin
export default {"container":"Bq-z","heading":"Cq-z","text":"Dq-z","info":"Eq-z","link":"Fq-z","fullMaxWidth":"Gq-z"};